// removed by extract-text-webpack-plugin
module.exports = {"leftpicturebackground":"src-components-Section----LeftPictureBackground-module---leftpicturebackground---2dtdl","fh5colabel":"src-components-Section----LeftPictureBackground-module---fh5colabel---1JjGr","fh5colead":"src-components-Section----LeftPictureBackground-module---fh5colead---3Ewwi","row-bottom-padded-lg":"src-components-Section----LeftPictureBackground-module---row-bottom-padded-lg---34-wm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/LeftPictureBackground.module.scss
// module id = 430
// module chunks = 168707334958949